import {CircularProgress} from '@material-ui/core'
import {GraphQLErrors} from 'components/graphql-errors'
import {useGetAuthUserQuery, UserFragment} from 'generated/graphql'
import {createContext, FC, useContext} from 'react'

type UserContextType = {
    user?: UserFragment
}

const UserContext = createContext<UserContextType>({
    user: undefined,
})

export const UserProvider: FC = ({children}) => {
    const {data, loading, error, refetch} = useGetAuthUserQuery({fetchPolicy: 'cache-first'})

    return (
        <UserContext.Provider value={{user: data?.authUser}}>
            {error && <GraphQLErrors error={error} refetch={refetch} />}
            {loading ? <CircularProgress color='primary' /> : children}
        </UserContext.Provider>
    )
}

export const useUser = () => useContext(UserContext)
